export const SupplierInvoiceColumns = [
  {
    id: "company_invoice_actions",
    title: "Actions",
  },
  {
    id: "date",
    title: "Date",
  },
  {
    id: "companyId",
    title: "Company",
  },
  {
    id: "itemId",
    title: "Item Name",
  },
  {
    id: "purchase",
    title: "Price",
  },
  {
    id: "qty",
    title: "Quantity",
  },
  {
    id: "total_amount",
    title: "Total Amount",
  },
  {
    id: "desc",
    title: "Description",
  },
  {
    id: "truck_no",
    title: "Truck No",
  },
  {
    id: "invoice_no",
    title: "Builti No",
  },
];
